import React, { Component } from 'react';
import './assets/css/main.css';
import $ from 'jquery';
import Main from './Main';
import logo from './03.png';
// import img1 from './images/01.jpg';
// import img2 from './images/02.jpg';
// import img3 from './images/03.jpg';
// import img4 from './images/04.jpg';


class App extends Component {
  componentDidMount() {
  }
  // set the copy right year
  copyright() {
    return new Date().getFullYear();
  }
  showSection(e) {
    let $content = e.target.getAttribute('data-attr'),
      event = new CustomEvent('show:content', {
        detail: {
          content: $content
        }
      });

    document.getElementById('main');
    document.dispatchEvent(event);
  }
  scrollToSection(e) {
    let section = $(e.target).attr('href');
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(section).offset().top
    }, 500);
  }
  render() {
    return (
      <div className='App'>
        <Main />
  			<section id='header'>
          <img src={logo} alt='WillowIS' className='logo'/>
          <footer>
            <nav id="nav">
  						<ul>
  							<li><a href='#banner' onClick={this.scrollToSection}>What we do</a></li>
							<li><a href='#ourteam' onClick={this.scrollToSection}>Our Team</a></li>
  							<li><a href='#contactus' onClick={this.scrollToSection}>Contact Us</a></li>
  						</ul>
            </nav>
  				</footer>
  			</section>


  			<section id='banner'>
  				<header>
  					<h2>What We Do</h2>
  				</header>
          <p>
            We specialize in developing bespoke systems and websites for
            small to medium sized enterprises.
          </p>
          <p>
            Whether it’s desktop, mobile or
            web based applications, we’ll get your organization away from using
            unsecure spreadsheets and into a world of database driven,
            distributed, secure applications.
		  </p>
		  <p>We also do data analysis to identify data trends which will help you better understand your business and customers
			The technologies used are as follows:

			<ul>
				<li>NodeJS</li>
				<li>React</li>
				<li>React Native</li>
				<li>C#</li>
				<li>MS SQL</li>
				<li>RethinkDB</li>
				<li>MongoDB</li>
				<li>Amazon Web Services</li>
			</ul>

          </p>
  		</section>
		  <section id='ourteam'>
  				<header>
  					<h2>Our Team</h2>
  				</header>
				<p>Our team consists of:
					<ul> 
						<li>Software Developers</li>
						<li>User Experience Developers</li>
						<li>Business Analysts</li>
						
					</ul>
				</p>  
			</section>


  			{/* <article id='first' className='container box style1 right'>
  				<a className='image fit'><img src={img1} alt='' /></a>
  				<div className='inner'>
  					<header>
  						<h2>Lorem ipsum<br />
  						dolor sit amet</h2>
  					</header>
  					<p>
              We specialize in developing bespoke systems and websites for
              small to medium sized enterprises. Whether it’s desktop, mobile or
              web based applications, we’ll get your organization away from using
              unsecure spreadsheets and into a world of database driven,
              distributed, secure applications.
            </p>
            <p>We also offer consulting services to assist with any of your IT needs</p>
  				</div>
  			</article>
        <article className='container box style1 left'>
  				<a className='image fit'><img src={img2} alt='' /></a>
  				<div className='inner'>
  					<header>
  						<h2>Mollis posuere<br />
  						lectus lacus</h2>
  					</header>
  					<p>Sample text and image</p>
  				</div>
  			</article>*/}

  			<article id='contactus' className='container box style3'>
  				<header>
  					<h2>Contact us</h2>
  					<p>Please contact us by completing the form below</p>
  				</header>
  				<form method='post' action='./php/mailer.php'>
  					<div className='row 50%'>
  						<div className='6u 12u$(mobile)'><input type='text' className='text' name='name' placeholder='Name' /></div>
  						<div className='6u 12u$(mobile)'><input type='text' className='text' name='email' placeholder='Email' /></div>
  						<div className='12u'>
  							<textarea name='message' placeholder='Message'></textarea>
  						</div>
  						<div className='12u'>
  							<ul className='actions'>
  								<li><input type='submit' value='Send Message' /></li>
  							</ul>
  						</div>
  					</div>
  				</form>
  			</article>

  		<section id='footer'>
  			<ul className='icons'>
  				<li>
            <div className='copyright'>
      				<ul className='menu'>
      					<li>&copy; {this.copyright()} Willow Information Services</li>
      				</ul>
      			</div>
          </li>
  			</ul>
  		</section>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js